package com.appcreator.client.firebase.appcheck

object FirebaseAppCheckInitializer {
    fun initialize(
        reCaptchaSiteKey: String,
    ) {
        platformAppCheckInitialize(reCaptchaSiteKey)
    }
    val headerKey = "X-Firebase-AppCheck"
}

expect fun platformAppCheckInitialize(reCaptchaSiteKey: String)